module.exports = __webpack_public_path__ + "static/media/file-alt-regular-green.8c403dea.jpg";